import { useSession } from "shared/hooks/useSession";

/*
* Язык заведения — свойство сессии, поэтому берётся прямо из неё. До загрузки аккаунта (и на
* экранах входа, где его ещё нет) отдаём русский: тот же дефолт, что стоял в сторе.
* */
export const DEFAULT_LOCALE_ID = "ru";

export const useLocale = (): string => {
    const { account } = useSession();

    return account ? account.localeId : DEFAULT_LOCALE_ID;
};
